import { render, staticRenderFns } from "./BuyersPurchaseInfosTable.vue?vue&type=template&id=35462c8a&"
import script from "./BuyersPurchaseInfosTable.vue?vue&type=script&lang=ts&"
export * from "./BuyersPurchaseInfosTable.vue?vue&type=script&lang=ts&"
import style0 from "./BuyersPurchaseInfosTable.vue?vue&type=style&index=0&id=35462c8a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports